import * as React from "react";

const SvgChartpie = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M11.024 3A9.029 9.029 0 1 0 21 12.976h-9.976V3Z" />
      <path d="M20.541 8.504h-5.504V3a9.053 9.053 0 0 1 5.504 5.504Z" />
    </g>
  </svg>
);

export default SvgChartpie;
